export default __webpack_public_path__ + "static/media/logo.c3297b57.png";